@let item = activite();
<section
  class="border-t-grey-3 border-r-grey-3 border-b-grey-3 border-l-grey-3 relative justify-between gap-2 rounded-md border-t-1 border-r-1 border-b-1 border-l-6 shadow-none hover:cursor-pointer"
  (click)="navigateToDetailsActivite(item.id)"
  hlmCard
>
  <div hlmCardHeader>
    <a class="paragraph-large-semibold hover:underline" hlmCardTitle>
      {{ item.nom }}
    </a>
    <div hlmCardAction>
      <ng-icon name="lucideArrowRight" />
    </div>
  </div>
  <div class="flex flex-col gap-4" hlmCardContent>
    <div class="text-grey-8 flex flex-col space-y-1">
      <p>
        <span class="paragraph-medium-semibold">Date de création :</span>&nbsp;<span class="paragraph-medium-medium">{{
          item.dateCreation | date: 'dd/MM/yyyy'
        }}</span>
      </p>
    </div>
  </div>
</section>
